<template>
  <div class="ps-table-wrap">
    <VeTable
      :fixed-header="true"
      :columns="columns"
      :table-data="tableData"
      :border-around="false"
      :sort-option="sortOption"
      :max-height="'calc(100vh - 210px)'"
    />
    <EmptyState
      v-if="!isLoading && showEmptyResult"
      :title="'No record found!'"
    />
    <div v-if="isLoading" class="campaign--loader">
      <Spinner />
      <span>{{ $t('COUPON.COUPON_LIST.LOADING') }}</span>
    </div>
  </div>
</template>

<script>
import { VeTable } from 'vue-easytable';
import Spinner from 'shared/components/Spinner.vue';
import { mapGetters } from 'vuex';
// import alertMixin from 'shared/mixins/alertMixin';
// import moment from 'moment';
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import WootButton from 'dashboard/components/ui/WootButton.vue';
// import Label from 'dashboard/components/ui/Label';

export default {
  components: {
    VeTable,
    Spinner,
    // Label,
    EmptyState,
  },
  props: {
    records: {
      type: Array,
      default: () => [],
    },
    cols: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sortConfig: {},
      sortOption: {
        sortAlways: true,
        sortIcons: {
          ascend: 'top-arrow',
          descend: 'bottom-arrow',
        },
        sortChange: params => {
          this.sortConfig = params;
          this.$emit('on-sort-change', params);
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      meta: 'tools/getMetaKnowledge',
    }),
    showEmptyResult() {
      return this.tableData.length === 0;
    },
    tableData() {
      return this.records;
    },
    columns() {
      let matches = {};
      matches.name = {
        field: 'name',
        key: 'name',
        title: 'Name',
        width: 180,
        align: 'left',
        ...(this.isSortable('name') && {
          sortBy: this.sortConfig.name || '',
        }),
      };
      matches.type = {
        field: 'kind',
        key: 'kind',
        title: 'Type',
        width: 180,
        align: 'left',
        ...(this.isSortable('kind') && {
          sortBy: this.sortConfig.kind || '',
        }),
      };
      matches.detail = {
        field: 'detail',
        key: 'detail',
        title: 'Detail',
        width: 300,
        align: 'left',
        ...(this.isSortable('detail') && {
          sortBy: this.sortConfig.detail || '',
        }),
      };
      matches.created_at = {
        field: 'created_at',
        key: 'created_at',
        title: 'Created At',
        width: 350,
        align: 'left',
        ...(this.isSortable('created_at') && {
          sortBy: this.sortConfig.created_at || '',
        }),
        renderBodyCell: ({ row }) => {
          const date = new Date(row.created_at);
          return date.toLocaleDateString('en-MY', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          });
        },
      };
      matches.action = {
        field: 'action',
        key: 'action',
        title: this.$t('COUPON.COUPON_LIST.TABLE_HEADER.ACTION'),
        align: 'center',
        width: 150,
        // fixed: this.isMobile ? false:'right',
        renderBodyCell: ({ row }) => {
          return (
            <div class="button-wrapper">
              <WootButton
                variant="link"
                icon="edit"
                color-scheme="secondary"
                onClick={() => this.$emit('on-edit-click', row)}
              ></WootButton>
              <WootButton
                variant="link"
                icon="dismiss-circle"
                color-scheme="secondary"
                onClick={() => this.$emit('on-delete-click', row)}
              ></WootButton>
            </div>
          );
        },
      };

      const preSet = [];
      this.cols.forEach(col => {
        if (col.visible) {
          if (col.key in matches) {
            preSet.push(matches[col.key]);
          }
        }
      });
      return preSet;
    },
  },
  methods: {
    isSortable(key) {
      return Array.isArray(this.meta?.sorts) && this.meta.sorts?.includes(key);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_ps_table.scss';

.tool_name {
  cursor: pointer;
}
</style>

<style lang="scss">
.ps-table-wrap {
  .ve-table-sort {
    display: inline-flex;
    flex-direction: column;
    margin-left: 4px;

    .ve-table-sort-icon {
      width: 14px !important;
      height: 14px !important;
      line-height: 1;

      svg {
        width: 14px !important;
        height: 14px !important;
      }
    }
  }

  .fluent-icon {
    width: 14px !important;
    height: 14px !important;

    svg {
      width: 14px !important;
      height: 14px !important;
    }
  }
}
</style>
